/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, memo, useState } from 'react';
import Script from 'next/script';
import { getConfig } from '@chegg-web-tools/config-plugin';
import { isMobile } from '@src/lib/hooks/useIsMobile';
import styled from 'styled-components';

declare global {
  interface Window {
    sbmCmd: any[];
  }
}

type AdScriptProps = {
  adPageId?: string;
};
const Ad = styled.div`
  overflow: hidden;
  position: absolute;
  width: 100vw;
  max-height: calc(100vh - 62px);
  top: auto;
  left: 0;
  max-width: 100%;
  iframe {
    width: 100%;
  }
`;

const AdScript: React.FC<AdScriptProps> = ({ adPageId }) => {
  const [showAds, setShowAds] = useState(false);

  useEffect(() => {
    // we dont want sbm if valueprops is shown or for any mobile device
    if (!window.location.search.includes('type=') && !isMobile()) {
      setShowAds(true);
    }
    if (!showAds) return;

    window.sbmCmd = window.sbmCmd || [];
    window.sbmCmd.push((sbmGlobalRun: any) => {
      if (adPageId) {
        sbmGlobalRun.reload({ page: adPageId });
      } else {
        sbmGlobalRun.reload();
      }
    });
  }, [adPageId, showAds]);

  if (!showAds) return null;

  return (
    <>
      <Ad id="D_T1" data-test="sbm_ad" />
      <Script async src={getConfig('sbmGdprUrl')} strategy="afterInteractive" />
      <Script async src={getConfig('sbmAds')} strategy="afterInteractive" />
    </>
  );
};

export default memo(AdScript);
